import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import instance from "../../../../../../axios/instance";

const QuestionItem = ({ item, index, isEditing, onChange }) => (
  <div className="p-4">
    {isEditing ? (
      <>
        <label className="block text-xs font-medium text-gray-500 mb-1">
          Question {index + 1}
        </label>
        <textarea
          value={item.question}
          onChange={(e) => onChange(index, "question", e.target.value)}
          className="w-full p-2 border border-gray-300 rounded-lg text-sm font-semibold text-gray-800 mb-2 resize-none focus:outline-none focus:ring-2 focus:ring-blue-500"
          rows={2}
        />
        <label className="block text-xs font-medium text-gray-500 mb-1">
          Answer
        </label>
        <textarea
          value={item.answer}
          onChange={(e) => onChange(index, "answer", e.target.value)}
          className="w-full p-2 border border-gray-300 rounded-lg text-sm text-gray-600 resize-none focus:outline-none focus:ring-2 focus:ring-blue-500"
          rows={3}
        />
      </>
    ) : (
      <>
        <h4 className="font-semibold text-sm text-gray-800">{item.question}</h4>
        <p className="text-sm text-gray-600 mt-1">{item.answer}</p>
      </>
    )}
  </div>
);

export const Questionnaires = ({
  questionnaires: initialQuestionnaires,
  questionnaireId,
  onRefresh,
  onEditClick,
  isEditing,
  onCancelEdit,
}) => {
  const [questionnaires, setQuestionnaires] = useState(initialQuestionnaires);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const token = window.sessionStorage.getItem("ACCESS_TOKEN");

  useEffect(() => {
    setQuestionnaires(initialQuestionnaires);
  }, [initialQuestionnaires]);

  const handleChange = (index, field, value) => {
    const updated = [...questionnaires];
    updated[index] = { ...updated[index], [field]: value };
    setQuestionnaires(updated);
  };

  const handleSave = async () => {
    if (!questionnaireId) {
      const msg = "No questionnaire ID available";
      setError(msg);
      toast.error(msg);
      return;
    }

    setLoading(true);
    setError("");

    try {
      await instance.put(
        `/doctor/questionnaire/${questionnaireId}`,
        { questionnaires },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      toast.success("Questionnaire updated successfully!");
      if (onRefresh) onRefresh();
      if (onCancelEdit) onCancelEdit();
    } catch (err) {
      const msg = err.response?.data?.message || "Failed to update questionnaire";
      setError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setQuestionnaires(initialQuestionnaires);
    if (onCancelEdit) onCancelEdit();
    setError("");
  };

  useEffect(() => {
    if (onEditClick) {
      onEditClick({ onSave: handleSave, onCancel: handleCancel, loading });
    }
  }, [loading, questionnaires]);

  return (
    <div className="mt-6">
      {error && (
        <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-600 text-sm">
          {error}
        </div>
      )}

      {questionnaires.length === 0 ? (
        <p className="py-8 text-center text-sm text-gray-500">No questionnaire data available.</p>
      ) : (
        <div className="grid grid-cols-2 divide-y divide-gray-200">
          {questionnaires.map((item, index) => (
            <QuestionItem
              key={index}
              item={item}
              index={index}
              isEditing={isEditing}
              onChange={handleChange}
            />
          ))}
        </div>
      )}
    </div>
  );
};
